exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h3[data-v-734464ee]{font-size:4.8vw;text-align:center;margin-top:10.66667vw;margin-bottom:10.66667vw;font-weight:400}", ""]);

// exports
